import type { ClientDeclarableBowerClient } from '@bower/shared';

/**
 * The one mobile-viewport rule.
 *
 * `47.9975em`, not `48em`: Chakra's `md` is `min-width: 48em`, so an exact
 * `max-width: 48em` matches BOTH at precisely 768px. `useIsMobileViewport`
 * imports this constant rather than re-spelling it, so the imperative helper
 * below and the hook cannot drift.
 *
 * `useMobileDetection` reads it too, for `isMobile` and the tablet range.
 */
export const MOBILE_VIEWPORT_QUERY = '(max-width: 47.9975em)';

/** Non-hook viewport test, usable outside React. */
export function isMobileViewport(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(MOBILE_VIEWPORT_QUERY).matches;
}

/**
 * Which Bower client this is, for `x-bower-client`.
 *
 * Not a hook: the axios request interceptor runs outside React. The
 * breakpoint is read per call so a resized window or a rotated tablet is
 * reflected on the next request rather than frozen at app start.
 */
export function currentBowerClient(): ClientDeclarableBowerClient {
  // Narrowed deliberately: this client can only ever be one of the two web
  // members, and the narrower return type makes it impossible for the frontend
  // to name a server-assigned client by accident. It is also what gives
  // `ClientDeclarableBowerClient` a consumer.
  return isMobileViewport() ? 'web-mobile' : 'web';
}
